// extracted by mini-css-extract-plugin
export var searchHeader = "_7v-0";
export var searchHeaderDark = "_7v-1";